'use client';

import { classNames } from '@schuelerhilfe/shared/src/utils/classNames';
import { useEffect, useRef, type ReactNode } from 'react';
import { Icon } from '@/components/Icon';

interface SubmittedCardProps {
  children: ReactNode;
  iconSize?: number;
  className?: string;
}

export const SubmittedCard = ({
  children,
  iconSize = 80,
  className = 'mx-auto text-center',
}: SubmittedCardProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    ref.current?.focus();
  }, []);

  return (
    <div
      ref={ref}
      role="status"
      tabIndex={-1}
      className={classNames(
        'focus-visible:outline-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2',
        className,
      )}
    >
      <div className="text-primary mb-6 flex justify-center">
        <Icon src="/icons/checkmark-circle.svg" size={iconSize} />
      </div>
      {children}
    </div>
  );
};
